// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Tv5U","content":"styles_content__mJ4s8","row":"styles_row__8CEJ2","footer":"styles_footer__2B0HY","phraseLength":"styles_phraseLength__17uQs"};